<template>
  <div class="upcoming-event-report-container">
    <div class="row">
      <div v-for="item in reports" class="col-md-6 col-lg-4">
        <EventCompletedReportCard :eventInfo="item"></EventCompletedReportCard>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EventCompletedReportCard from '../../commons/EventCompletedReportCard';
  import _ from 'lodash';
  
  export default {
    name: 'c-completed-report',
    components: {
      EventCompletedReportCard
    },
    data () {
      return {
        reports: [],
        pagingObj: {
          currentPage: 0,
          itemsPerPage: 10
        }
      }
    },
    props: {
      reportType: {
        type: String,
        required: true
      },
      dateOut: {
        type: Array,
        default: () => ['0', '60+']
      },
      filterBy: {
        type: Array,
        default: () => ['dateTime']
      },
      textSearch: {
        type: String,
        required: false
      }
    },
    computed: {
      ...mapGetters({
        getEventListReports: 'GETTER_GET_EVENT_LIST_REPORTS'
      })
    },
    methods: {
      getDataReport (params) {
        let body = {
          noBeginDates: this.dateOut[0],
          noEndDates: this.dateOut[1],
          selectedDate: null,
          clientId: this.$route.params.clientId,
          keyword: this.textSearch,
          currentPage: this.pagingObj.currentPage || 1,
          itemsPerPage: this.pagingObj.itemsPerPage || 25,
          sortType: this.filterBy[0],
          eventStatus: 'completed',
          requireReport: true,
          ...params
        };
        this.getEventsByDate(body).then((response) => {
          if (response.message === null) {
            this.reports = response.approvedEvents[0].events;
          } else {
            this.reports = [];
          }
        });
      },
      getEvents () {
      },
      ...mapActions({
        getEventsByDate: 'ACTION_GET_EVENTS_BY_DATES',
        actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
      })
    },
    created () {
      let params = {
        noBeginDates: '0',
        noEndDates: '60+'
      };
      this.getDataReport(params);
    },
    watch: {
      filterBy: {
        handler: function (val, oldVal) {
          if (val[0] === oldVal[0]) {
            return;
          }
          let params = {
            sortType: val[0],
            noBeginDates: '0',
            noEndDates: '60+'
          };
          this.getDataReport(params);
        },
        deep: true
      },
      textSearch: _.debounce(function () {
        let keyword = this.textSearch.trim().toLowerCase();
        if (keyword.length >= 2 || keyword.length === 0) {
          this.getDataReport({ keyword: keyword });
        }
      }, 700)
    }
  };
</script>



// WEBPACK FOOTER //
// CompletedReport.vue?ac407910